import { inject, NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { Store } from '@ngrx/store';

import { AppMainComponent } from 'app/core/components/main';
import { UpdatePwaComponent } from 'app/core/components/update-pwa';
import {
    apiConfigToBeSetGuardFn,
    authorizationGuardFn,
    settingsLoadedGuardFn,
    setupFinishedGuardFn,
} from 'app/core/guards';
import { rootPaths, terminalChildRoutePaths } from 'app/core/routing/route-paths';
import { AppDeveloperComponent } from 'app/features/developer';
import { HardResetComponent } from 'app/features/hard-reset';
import { AppSettingsComponent } from 'app/features/settings';
import { AppSetupWizardComponent } from 'app/features/setup-wizard';
import { UserSessionSigninComponent } from 'app/features/user-session-signin';
import { ReloadRouteReuseStrategy } from 'app/reload-route-reuse.strategy';
import { selectIsUpdateAvailable } from 'app/state/service-worker/service-worker.selectors';
import { environment } from 'environments/environment';

const childRoutes: Routes = [
    {
        path: terminalChildRoutePaths.setup,
        component: AppSetupWizardComponent,
        canActivate: [settingsLoadedGuardFn, apiConfigToBeSetGuardFn],
    },
    {
        path: terminalChildRoutePaths.hardReset,
        component: HardResetComponent,
    },
    {
        path: terminalChildRoutePaths.settings,
        component: AppSettingsComponent,
        canActivate: [settingsLoadedGuardFn, setupFinishedGuardFn],
    },
    {
        path: terminalChildRoutePaths.signin,
        component: UserSessionSigninComponent,
        canActivate: [settingsLoadedGuardFn, setupFinishedGuardFn],
    },
];

if (!environment.production) {
    childRoutes.push({
        path: 'dev',
        component: AppDeveloperComponent,
        canActivate: [settingsLoadedGuardFn],
    });
}

const routes: Routes = [
    {
        path: rootPaths.error,
        loadChildren: () => import('app/core/routing/error-pages.module').then((m) => m.AppErrorPagesModule),
    },
    {
        path: '',
        component: AppMainComponent,
        children: [
            {
                path: '',
                canActivate: [settingsLoadedGuardFn, setupFinishedGuardFn, authorizationGuardFn],
                loadChildren: () =>
                    import('app/features/terminal/terminal.routes').then((m) => m.TERMINAL_ROUTES),
            },
            ...childRoutes,
        ],
    },
    {
        path: rootPaths.update,
        component: UpdatePwaComponent,
        canActivate: [() => inject(Store).select(selectIsUpdateAvailable)],
    },
    { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
        }),
    ],
    exports: [RouterModule],
    providers: [{ provide: RouteReuseStrategy, useClass: ReloadRouteReuseStrategy }],
})
export class AppRoutingModule {}
